<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp_FILL0_wght400_GRAD0_opsz24.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'fast_pay.get_fast_pay_cta' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-padding-bottom">
      <ion-col size="12">
        <div class="fastpay-icon">
          <img
            src="assets/img/fast_pay_icon.svg"
            alt="{{ 'fast_pay.request_fast_pay' | translate }}"
          />
        </div>
        <h2 class="ion-margin-top-0">{{ 'fast_pay.request_fast_pay' | translate }}</h2>
        <p>
          {{ 'fast_pay.request_fast_pay_description' | translate }}
        </p>
        <p>{{ 'fast_pay.request_fast_pay_requirements' | translate }}</p>
        <ul>
          <li>{{ 'fast_pay.request_fast_pay_requirements_company' | translate }}</li>
          <li>{{ 'fast_pay.request_fast_pay_requirements_freight' | translate }}</li>
          <li>{{ 'fast_pay.request_fast_pay_requirements_application' | translate }}</li>
        </ul>

        @if (hasExpiredCompanyDocuments()) {
          <div class="messages-ui error">
            <strong>¡La documentación de tu empresa no está actualizada!</strong>
          </div>
        }

        <lib-fastpay-info-conditions></lib-fastpay-info-conditions>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="closeModalWithAccept()"
            color="primary"
            expand="block"
            fill="solid"
            size="default"
          >
            {{ buttonText() }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
